window.GetData = function(){
    if(typeof Cookies.get('globals') != "undefined")
        return JSON.parse(new Buffer(Cookies.get('globals'), 'base64').toString('utf8'));

    return {};
};

window.SetData = function(Data){
    Cookies.set('globals', new Buffer(JSON.stringify(Data)).toString('base64'));
};

window.RemoveData = function(){
    Cookies.remove('globals');
};

window.HasRole = function(roles){

    let exists = false;

    if(typeof roles != 'object')
        roles = [roles];

    let data = window.GetData();
    if(!data) return exists;

    let currentUser = data.currentUser;
    if(!currentUser) return exists;

    let userRoles = currentUser.roles;

    userRoles.forEach(function(userRole){
        if(userRole == 'admin' || userRole == 'superadmin')
            if(!exists) exists = true;

        roles.forEach(function(role){
            if(!exists) exists = userRole == role;
        });
    });

    return exists;
};



window.ParseDate = function(date){
    if(!date || typeof date == 'undefined')
        return date;

    let v = new Date(Date.parse(date.replace(/\-/ig, '/').split('.')[0]));

    if(v == 'Invalid Date')
        v = new Date(date);

    return v;
}


/** WEBPACK FOOTER **
 ** ./js/globals.js
 **/